
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HoraPipe } from './../pipes/horas.pipe';
import { RespuestaComponent } from './eventos-perfil/compra/respuesta/respuesta.component';
import { CompraComponent } from './eventos-perfil/compra/compra.component';
import { EventosPerfilComponent } from './eventos-perfil/eventos-perfil.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { ImagenEventosComponent } from './eventos-perfil/imagen-eventos/imagen-eventos.component';

import { MatIconModule } from '@angular/material/icon';
import { HttpInterceptBasicAuthService } from '../service/http/http-intercept-basic-auth.service';
import { CountdownModule } from 'ngx-countdown';
import { CantidadBoletasComponent } from './eventos-perfil/compra/cantidad-boletas/cantidad-boletas.component';
import { LocalidadSeleccionComponent } from './eventos-perfil/compra/localidad-seleccion/localidad-seleccion.component';


import { RedesSocialesComponent } from 'redes-sociales/redes-sociales.component';
import { CarritoFinalComponent } from './eventos-perfil/compra/carrito-final/carrito-final.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ComprasPendientesComponent } from './eventos-perfil/pago-pay-u/compras-pendientes/compras-pendientes.component';
import { ConfirmacionComponent } from './eventos-perfil/pago-pay-u/confirmacion/confirmacion.component';
import { MapaComponent } from './eventos-perfil/compra/mapa/mapa.component';
import { EventosComponent } from './eventos.component';
import { CodigoCortesiaComponent } from './eventos-perfil/codigo-cortesia/codigo-cortesia.component';
import { CompraOcultaComponent } from './eventos-perfil/compra/compra-oculta/compra-oculta.component';


const routes: Routes = [
  {
    path: '',
    children: [

      {
        path: 'evento/:id',
        component: EventosPerfilComponent,
      },

      {
        path: 'evento/:id/compra',
        component: CompraComponent,
      },

      {
        path: 'evento/:id/compra-privada',
        component: CompraOcultaComponent,
      },
      {
        path: ':id/cortesia/:codigoId',
        component: CodigoCortesiaComponent,
      },
      {
        path:'carrito/:idOrden',
        component: CarritoFinalComponent
      },
      {
        path: 'evento/:id/compra/:codigoVenta/promotor',
        component: CompraComponent,
      },

      {
        path: 'respuesta/:idOrden',
        component: RespuestaComponent,

      },

      {
        path: 'carrito-de-compras',
        component: ComprasPendientesComponent,

      },
      {
        path: '',
        component: EventosComponent,
      }
    ],
  },
];

@NgModule({ declarations: [
        EventosPerfilComponent,
        CompraComponent,
        RespuestaComponent,
        HoraPipe,
        CarritoFinalComponent,
        ImagenEventosComponent,
        CantidadBoletasComponent,
        LocalidadSeleccionComponent,
        RedesSocialesComponent,
        ComprasPendientesComponent,
        ConfirmacionComponent,
        MapaComponent,
        CodigoCortesiaComponent,
        CompraOcultaComponent
    ], imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        CountdownModule,
        MatDialogModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptBasicAuthService,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class EventosModule {}
